import { lazy, Suspense } from "react";

import appRoutes from "./(app)/routes";

const AppLayout = lazy(() => import("./(app)/layout"));
const AuthorizeAdminMcpPage = lazy(() => import("./authorize/page"));

const withSuspense = (Component: React.ComponentType) => (
  <Suspense fallback={<div>Loading...</div>}>
    <Component />
  </Suspense>
);

const routes = [
  // Consent OAuth — вне лэйаута админки: это отдельный экран без навигации,
  // на который редиректит MCP-клиент. Авторизация уже проверена RootLayout.
  {
    path: "authorize",
    element: withSuspense(AuthorizeAdminMcpPage),
  },
  {
    element: withSuspense(AppLayout),
    children: appRoutes,
  },
];

export default routes;
